import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../theme/constants';
import config from '../../../config';

export const HomeContentContainer = styled.div<{ isMobile?: boolean }>`
   max-width: 100%;
   background-color: white;
   padding: 20px ${p => (p.isMobile ? 20 : 0)}px;
`;

export const HomeContentWrapper = styled.div`
   max-width: 1028px;
   margin: 0 auto;
`;

export const HomeContentLinks = styled.ul`
   -webkit-column-count: 1;
   -moz-column-count: 1;
   column-count: 1;

   list-style: none;
   margin: 5px 0;
   padding: 0px;

   li {
      margin: 0;
      padding: 5px;

      a {
         font-size: 16px;
         line-height: 1.2;
         font-weight: 300;
         color: ${COLOR.DARKGREY} !important;
         text-decoration: none !important;
         cursor: pointer;

         &:hover {
            text-decoration: none;
            color: ${COLOR.DARKGREY};
         }

         &.active {
            ${TYPOGRAPHY.BOLD}
            color: ${COLOR.BLUE} !important;
         }
      }
   }

   > li {
      padding: 5px 0;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
   }

   @media (min-width: 1024px) {
      -webkit-column-count: 3;
      -moz-column-count: 3;
      column-count: 3;
   }
`;
